import { normalizeStrapiLegalResponse } from './wpService';

const STRAPI_API_BASE_URL = process.env.REACT_APP_STRAPI_URL || 'https://cms-v2.subscribili.com';
const STRAPI_API_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;
const STRAPI_DATA_STATUS = process.env.REACT_APP_STRAPI_DATA_STATUS;

const fetchService = async (endPoint, cacheOptions = {}, headers = {}) => {
    try {
        const api = '/api';
        const separator = endPoint.includes('?') ? '&' : '?';
        // status=draft → returns draft content; omitting status defaults to published only
        const draftParam = STRAPI_DATA_STATUS ? `${separator}status=${STRAPI_DATA_STATUS}` : '';
        const url = `${STRAPI_API_BASE_URL}${api}${endPoint}${draftParam}`;

        const requestHeaders = {
            'Content-Type': 'application/json',
            ...headers,
        };

        if (STRAPI_API_TOKEN) {
            requestHeaders.Authorization = `Bearer ${STRAPI_API_TOKEN}`;
        }

        const response = await fetch(url, {
            headers: requestHeaders,
            ...cacheOptions,
        });

        if (!response.ok) {
            throw new Error(`Strapi API error: ${response.status}`);
        }

        const data = await response.json();
        const normalized = normalizeStrapiLegalResponse(data);

        return { data: normalized };
    } catch (error) {
        console.error('Strapi fetch failed:', error);
        throw error; 
    }
};

export const fetchGroupUiConfig = async (groupId) => {
    if (!groupId) return {};
    try {
        const endpoint = `/group-configs?filters[group_id][$eq]=${groupId}&populate=label_overrides`;
        const separator = endpoint.includes('?') ? '&' : '?';
        // status=draft → returns draft content; omitting status defaults to published only
        const draftParam = STRAPI_DATA_STATUS ? `${separator}status=${STRAPI_DATA_STATUS}` : '';
        const url = `${STRAPI_API_BASE_URL}/api${endpoint}${draftParam}`;

        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                ...(STRAPI_API_TOKEN && { Authorization: `Bearer ${STRAPI_API_TOKEN}` }),
            },
        });
        if (!response.ok) throw new Error(`Strapi error: ${response.status}`);

        const json = await response.json();
        const labelOverrides = json?.data?.[0]?.label_overrides || [];
        return labelOverrides.reduce((map, item) => {
            const { key, value } = item || {};
            if (key && value) map[key] = value;
            return map;
        }, {});
    } catch (err) {
        console.error(`Error fetching group UI config for ${groupId}:`, err);
        return {};
    }
};

export default fetchService;